var _g, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 111,
    viewBox: "0 0 117 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16440_10034)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.74609,
    y: 3.11914,
    width: 78.0681,
    height: 98.209,
    rx: 8.91188,
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0625,
    y: 3.65234,
    width: 75.0381,
    height: 96.6048,
    rx: 8.0207,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6797 25.9326L70.8412 25.9326",
    stroke: "#E1E1E1",
    strokeWidth: 3.03004,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6797 47.6777H65.4941",
    stroke: "#E1E1E1",
    strokeWidth: 3.03004,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6797 55.5205H56.7605",
    stroke: "#E1E1E1",
    strokeWidth: 3.03004,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6797 77.6221H53.7304",
    stroke: "#E1E1E1",
    strokeWidth: 3.03004,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6797 69.5137H60.6826",
    stroke: "#E1E1E1",
    strokeWidth: 3.03004,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6797 33.7754H61.7511",
    stroke: "#E1E1E1",
    strokeWidth: 3.03004,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7569,
    y: 44.1134,
    width: 11.0507,
    height: 11.5855,
    rx: 1.06943,
    stroke: "#C8C8C8",
    strokeWidth: 2.13885
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7266 50.1722C26.7266 50.1722 25.6572 49.1919 25.0334 48.6572C24.5718 48.2617 23.8545 48.4903 23.4292 48.9246C23.0276 49.3347 22.8434 50.0511 23.1619 50.5287C23.4803 51.0063 25.3898 52.9349 25.5681 53.1132C25.7953 53.3404 26.5284 53.8261 26.9049 53.8261C27.3505 53.8261 27.6517 53.614 27.8852 53.3805C30.1131 51.1525 33.5887 47.4095 37.4208 43.1319C37.8547 42.6476 37.6759 41.7452 37.2426 41.2604C36.8161 40.7834 35.7492 40.5559 35.282 40.993C32.5193 43.5775 26.7266 50.1722 26.7266 50.1722Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7569,
    y: 66.0372,
    width: 11.0507,
    height: 11.5855,
    rx: 1.06943,
    stroke: "#C8C8C8",
    strokeWidth: 2.13885
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8008 72.0629C26.8008 72.0629 25.7315 71.0825 25.1076 70.5479C24.646 70.1523 23.9287 70.3809 23.5034 70.8152C23.1019 71.2253 22.9177 71.9418 23.2361 72.4193C23.5545 72.8969 25.4641 74.8256 25.6423 75.0038C25.8695 75.231 26.6026 75.7167 26.9791 75.7167C27.4247 75.7167 27.7259 75.5046 27.9594 75.2711C30.1874 73.0431 33.6629 69.3001 37.495 65.0225C37.9289 64.5382 37.7501 63.6358 37.3168 63.1511C36.8904 62.674 35.8235 62.4465 35.3562 62.8837C32.5935 65.4681 26.8008 72.0629 26.8008 72.0629Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7569,
    y: 22.1915,
    width: 11.0507,
    height: 11.5855,
    rx: 1.06943,
    stroke: "#C8C8C8",
    strokeWidth: 2.13885
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8008 28.2172C26.8008 28.2172 25.7315 27.2368 25.1076 26.7021C24.646 26.3066 23.9287 26.5352 23.5034 26.9695C23.1019 27.3796 22.9177 28.0961 23.2361 28.5736C23.5545 29.0512 25.4641 30.9799 25.6423 31.1581C25.8695 31.3853 26.6026 31.871 26.9791 31.871C27.4247 31.871 27.7259 31.6589 27.9594 31.4254C30.1874 29.1974 33.6629 25.4544 37.495 21.1768C37.9289 20.6925 37.7501 19.7901 37.3168 19.3054C36.8904 18.8283 35.8235 18.6008 35.3562 19.038C32.5935 21.6224 26.8008 28.2172 26.8008 28.2172Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.8346,
    cy: 92.9508,
    r: 18.8932,
    fill: "#DDE4EF"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.3844,
    cy: 107.476,
    rx: 48.3024,
    ry: 3.2974,
    fill: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.4453 43.222L93.923 10.6045L109.786 21.0314L88.6649 53.6489L72.4453 43.222Z",
    fill: "#989898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.262 17.4664L98.7369 13.8125L77.4375 46.5191L83.1411 50.0839L104.262 17.4664Z",
    fill: "#989898"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0531 5.21102L93.8359 10.6032L109.788 21.1192L113.512 15.2265C115.331 12.3492 114.424 8.53891 111.503 6.78997L105.371 3.11711C102.496 1.39535 98.77 2.3334 97.0531 5.21102Z",
    fill: "#B5B5B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1406 50.0833L104.262 17.4658L109.787 21.1197L88.666 53.6481L83.1406 50.0833Z",
    fill: "#B7B7B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.916 11.6719C109.133 9.35668 110.5 6.14648 110.5 6.14648L111.235 6.58516C114.344 8.44208 115.301 12.5026 113.349 15.5529L109.787 21.1185L104.262 17.5537C104.262 17.5537 106.744 13.8998 107.916 11.6719Z",
    fill: "#B5B5B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7539 54.2714L72.4472 43.2207L88.6668 53.6476L79.2202 59.8859C79.2202 59.8859 76.5956 58.3087 74.9425 57.2124C73.2893 56.1161 70.7539 54.2714 70.7539 54.2714Z",
    fill: "#B6B6B6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6837 61.0445C69.8263 60.3316 70.7531 54.2715 70.7531 54.2715C70.7531 54.2715 73.3777 56.027 75.0308 57.1233C76.684 58.2196 79.2194 59.886 79.2194 59.886C79.2194 59.886 75.9222 62.2922 72.8029 64.1637C71.7335 64.8053 70.6522 64.7875 69.8619 63.9854C69.149 63.2619 69.5234 61.8466 69.6837 61.0445Z",
    fill: "#B5B5B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.025 54.1835C81.3192 52.6796 83.1441 50.084 83.1441 50.084L88.6695 53.6487L79.2229 59.8871L76.3711 58.0156C76.3711 58.0156 78.7083 55.7135 80.025 54.1835Z",
    fill: "#B6B6B6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2512 61.1338C74.5305 59.9078 76.3704 58.0146 76.3704 58.0146L79.2222 59.8861C79.2222 59.8861 74.4989 63.0944 72.3601 64.4312C71.9764 64.671 71.3756 64.7087 70.9342 64.6094C70.521 64.5165 70.043 64.1638 70.043 64.1638C70.043 64.1638 71.9886 62.3439 73.2512 61.1338Z",
    fill: "#B5B5B5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.1549,
    cy: 87.7819,
    r: 18.8932,
    fill: "#B5B5B5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94.1914,
    y: 77.0879,
    width: 4.45594,
    height: 21.3885,
    rx: 2.22797,
    fill: "#FEFEFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8164,
    y: 90.0986,
    width: 4.45594,
    height: 21.3885,
    rx: 2.22797,
    transform: "rotate(-90 85.8164 90.0986)",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16440_10034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.0681,
    height: 98.209,
    fill: "white",
    transform: "translate(7.74609 3.11914)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.27de73260c89a689b54ded8328a4e678.svg";
export { ForwardRef as ReactComponent };